import React from "react";
import { Button, Col, Dropdown, Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Utils } from "../../Common/Utilis";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import Joi from "joi-browser";
import { DropDownList } from "../Reports/common-components/dropdown-list";
import OutsideClickHandler from "react-outside-click-handler";
import Calendar from 'react-calendar';
import { MaintenanceLocationSlideOut } from "./MaintenanceLocationSlideOut";
import { AddProcedure } from "./AddProcedure";
import BootstrapTable from "react-bootstrap-table-next";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { FacilityMaintenance } from "../../Common/Services/FacilityMaintenance";
import { resolve, reject } from "q";
export class AddMaintenanceSchedule extends React.Component<any, any> {
  private FormSchema = Joi.object({
    name: Joi.string()
      .required()
      .error((errors) => {
        return errors.map((error) => {
          return { message: "Please enter a Name" };
        });
      }),

    startDate: Joi.string()
      .required()
      .error((errors) => {
        return errors.map((error) => {
          return { message: "Please select Start Date" };
        });
      }),

    // dueDate: Joi.string()
    //   .required()
    //   .error((errors) => {
    //     return errors.map((error) => {
    //       return { message: "Please select Location" };
    //     });
    //   }),
    frequency: Joi.string()
      .required()
      .min(1)  
      .error((errors) => {
        return errors.map((error) => {
          return { message: "Please enter a Frequency" };
        });
      }),
    frequenId: Joi.number()
      .required()
      .min(1)
      .error((errors) => {
        return errors.map((error) => {
          return { message: "Please populate all required fields before continuing" };
        });
      }),
      mainFrequenId: Joi.number()
      .required()
      .min(1)
      .error((errors) => {
        return errors.map((error) => {
          return { message: "Please select a Frequency" };
        });
      }),
    description: Joi.string().max(200)
    .error((errors) => {
      return errors.map((error) => {
        return { message: "Please enter a Description" };
      });
    })
    // .optional().allow('')
  });
  private violationRef:any;
  private refAddProcedure:any;
  constructor(props: any) {
    super(props);
    this.violationRef = React.createRef();
    this.refAddProcedure = React.createRef();
    this.state = {
      FormData: {
        name: '',
        startDate: '',
       // dueDate: '',
        frequency: '',
        frequenId: 1,
        mainFrequenId: -1,
        description:'',
        endDate:'',
        // location:-1
      },
      isFormNotValid: true,

      pageLoader: false,
      showAddNewPmProject: true,
      errors: {},
      calendarOpened: false,
      endCalendarOpened: false,
      dueDatecalendarOpened: false,
      freequencyList: [{ id: 1, name: "Days" }, { id: 2, name: "Weeks" }, { id: 3, name: "Months" }, { id: 4, name: "Years" }],
      mainFrequencyList: [{ id: 1, name: "Daily" }, { id: 2, name: "Weekly" }, { id: 3, name: "Monthly" }, { id: 5, name: "Quarterly" } ,{ id: 4, name: "Yearly" },{ id: 6, name: "Custom" }],
      inputPosition: 0,
      currentDate: "",
      hidValue:this.props.hid,
      proceduresList: [],
      tableProceuresData: [],
      showCustomdropdown:false,
      tableLocationData:[],
      frequenValidation:false,
      zeroValidation:false,
      isDuplicate:false,
    };
  }


  componentDidMount = () => {  
    let todayDate: any = new Date(); 
    todayDate.setDate(todayDate.getDate() + 1) 
    this.setState({ currentDate: todayDate })
    console.log( "tomarrow" + this.state.currentDate);
    
  }

  hideNewPmProject = () => {
    this.props?.iscloseModulePopup();
  }

  openCalendar = (inputPosition) => {
    this.setState({
      calendarOpened: inputPosition === 1,
      endCalendarOpened: inputPosition === 2,
    });
    if (this.violationRef.current) {
      this.violationRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  };
  closeCalendar = (inputPosition) => {
    this.setState({
      FormData: {
        ...this.state.FormData,
        endDate: '',
      },
      endCalendarOpened: false,
    });
    if (this.violationRef.current) {
      this.violationRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };
  dueDateCalender = () => {

    this.setState({ dueDatecalendarOpened: true });
  }


  calenderHide = () => {
    this.setState({ calendarOpened: false, dueDatecalendarOpened: false,endCalendarOpened:false });
    if (this.violationRef.current) {
      this.violationRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };
//   AddMaintenceClick = () => {
//    // debugger;
//    // this.validationOnClick(4);
//   //  const {
//   //   FormData: {
//   //     name,
//   //     startDate,
//   //     dueDate,
//   //     frequency,
//   //     frequenId
//   //     // location,
//   //     // description
//   //   },
//   //   errors,
//   //   isDataSaving,
//   //   isFormNotValid,
//   //   inputPosition,
//   //   dateList,
//   //   freequencyList,

//   // } = this.state;


//    let newErrorObject=this.validateConfigurationFormSchema();
//    if (Object.keys(newErrorObject).length > 0) {
//     this.setState({inputPosition:4});
//     return;
//    }
//  // this.validationOnClick(4);
//   //  if(this.state.isFormNotValid){
   
//   //   return
//   //  }
   
//     if(this.state.FormData.frequency==="0"){
//       toast.success("Frequency value should be greater than zero", {
//         position: toast.POSITION.BOTTOM_RIGHT,
//               containerId: "AddMaintenanceSchedule",
//       });
//       return;
//     }


//     let NextDueDate = "";
//     let maintenceData: any = {};
//     maintenceData.id = 0;
//     maintenceData.name = this.state.FormData.name;
//     maintenceData.startDate =  moment(this.state.FormData.startDate).format("MM/DD/YYYY");;

//     if (this.state.FormData.frequenId === 1) {
//       NextDueDate = moment(this.state.FormData.startDate).add(Number(this.state.FormData.frequency), "days").format("MM/DD/YYYY");;
//     }
//     if (this.state.FormData.frequenId === 2) {
//       NextDueDate = moment(this.state.FormData.startDate).add(Number(this.state.FormData.frequency), "months").format("MM/DD/YYYY");;
//     }
//     if (this.state.FormData.frequenId === 3) {
//       NextDueDate = moment(this.state.FormData.startDate).add(Number(this.state.FormData.frequency), "years").format("MM/DD/YYYY");;
//     }

//     maintenceData.dueDate = moment(NextDueDate).add(-1, "days").format("MM/DD/YYYY");
//     maintenceData.frequency = this.state.FormData.frequency;
//     maintenceData.frequenId = this.state.FormData.frequenId;
//     maintenceData.nextOccurrenceDate =  moment(this.state.FormData.startDate).format("MM/DD/YYYY");
//     maintenceData.priority = "";
//     maintenceData.isChanges = true;
//     maintenceData.isNew = true;

//     this.props?.iscloseModulePopup();
//     this.props?.isRequestSave(maintenceData);
//   };
isFormCompletelyValid = () => {
  const {
    name,
    startDate,
    frequency,
    frequenId,
    mainFrequenId,
    description,
  } = this.state.FormData;

  const isCustom = mainFrequenId === 6;

  const isNameValid = name?.trim() !== "";
  const isStartDateValid = startDate?.trim() !== "";
  const isDescriptionValid = description?.trim() !== "";
  const isMainFrequencyValid = mainFrequenId > 0;

  const isCustomFrequencyValid = isCustom
    ? frequency?.trim() !== "" && Number(frequency) > 0 && frequenId > 0
    : true;

  const isLocationValid = this.state.tableLocationData?.length > 0;
  const isDuplicate = !this.state.isDuplicate;

  return (
    isNameValid &&
    isStartDateValid &&
    isDescriptionValid &&
    isMainFrequencyValid &&
    isCustomFrequencyValid &&
    isLocationValid &&
    isDuplicate
  );
};
  onSaveMaintenance = () => {
     this.validationOnClick(5);
    //  if(!this.state.isFormNotValid)
    //  {
      let tableLocationData = [...this.state.tableLocationData];
      let tempProceuresData = [...this.state.tableProceuresData];
      if(tableLocationData.length===0){
        toast.error("Please add atleast one location", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "MaintenceShudleSldieOut",
        });
        return;
      }
      const isProjectNameExists = this.props.allMaintenanceSchedule.some(project => project.projectName.trim().toLowerCase() === this.state.FormData.name.trim().toLowerCase());
      if (isProjectNameExists) {
        toast.error("A schedule with this name already exists. Please choose a unique name.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        this.props.iscloseModulePopup();
        return;
      } 
  
      let mainData: any = [];
      let mainDataObject: any = {};
      const storage = JSON.parse(localStorage.getItem("storage")!);
      let User_UniqueID = storage === null ? 0 : (storage.user_UniqueID as any);
      let TenantId = storage === null ? 0 : (storage.tenantID as any);
      mainDataObject.ProjectName = this.state.FormData?.name;
      mainDataObject.Description = this.state.FormData?.description;
      mainDataObject.StartDate = moment(this.state.FormData?.startDate).format("MM/DD/YYYY");
      // let nextStartDate = "";
      // const frequencyUnit = this.state.showCustomdropdown ? this.state.FormData.frequenId : this.state.FormData.mainFrequenId;
      // const frequencyValue = this.state.showCustomdropdown ? this.state.FormData.frequency : 1;
      // const frequencyMapping = {
      //   1: 'days',
      //   2: 'weeks',
      //   3: 'months',
      //   4: 'years',
      //   5: 'quarters',
      // };
      // // Check for valid frequency
      // if (frequencyMapping[frequencyUnit]) {
      //   nextStartDate = moment(this.state.FormData.startDate)
      //     .add(Number(frequencyValue), frequencyMapping[frequencyUnit])
      //     .format("MM/DD/YYYY");
      // }
      mainDataObject.NextStartDate = moment(this.state.FormData?.startDate).format("MM/DD/YYYY");    
      mainDataObject.EndDate = moment(this.state.FormData?.endDate).format("MM/DD/YYYY");
      if(this.state.showCustomdropdown)
      {
        mainDataObject.Frequency = this.state.FormData?.frequenId == "1" ?
                                  (this.state.FormData.frequency == 1 ? "Day" : "Days") : this.state.FormData?.frequenId == "2" ? 
                                  (this.state.FormData.frequency == 1 ? "Week" : "Weeks") : this.state.FormData?.frequenId == "3" ? 
                                  (this.state.FormData.frequency == 1 ? "Month" : "Months") : this.state.FormData?.frequenId == "4" ? 
                                  (this.state.FormData.frequency == 1 ? "Year" : "Years") : "";
        mainDataObject.FrequencyValue = this.state.FormData?.frequency;
      }
      else{
        mainDataObject.Frequency = this.state.FormData?.mainFrequenId == "1" ?
                                  "Daily" : this.state.FormData?.mainFrequenId == "2" ? 
                                  "Weekly" : this.state.FormData?.mainFrequenId == "3" ? 
                                  "Monthly" : this.state.FormData?.mainFrequenId == "4" ? 
                                  "Yearly" : this.state.FormData?.mainFrequenId == "5" ? 
                                  "Quarterly" : "";
        mainDataObject.FrequencyValue = "1";
      }
      mainDataObject.Hid = Number(this.props.hid);
      mainDataObject.TenantId = TenantId;
      mainDataObject.Pririty = "";
      let procedureData: any = [];
      tempProceuresData.forEach(element => {
        let procedureDataObject: any = {};
        procedureDataObject.ProcedureId = element.procedureId;
        procedureData.push(procedureDataObject);
      });
      let locationData: any = [];
      tableLocationData.forEach(element => {
        let locationDataObject: any = {};
        locationDataObject.LocationId = element.id;
        locationData.push(locationDataObject);
      });
  
      let request: any = {};
      request.scheduleMaintenanceRequest = JSON.parse(JSON.stringify(mainDataObject));
      request.procedureIds = JSON.parse(JSON.stringify(procedureData));
      request.locationIds = JSON.parse(JSON.stringify(locationData));
  
      FacilityMaintenance.SaveMaintenance(request)
        .then(async (result: any | null) => {
          if (result !== null) {
            if (result.saveStatus === "Success") {
              toast.success("Maintenance Schedule saved successfully", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "MaintenceShudleSldieOut",
              });
              this.props.isSavecloseModulePopup();
            }
          }
          resolve();
        })
        .catch((error) => {
          reject();
        });
      // }
      // else{
      //   toast.error("Please populate all required fields before Save.", {
      //     position: toast.POSITION.BOTTOM_RIGHT,
      //     containerId: "MaintenceShudleSldieOut",
      //   });
      // }
  
  }

  validationOnClick = (inputPosition) => {
    // if(inputPosition !== 3){
      this.setState({ inputPosition }, () =>
        this.validateConfigurationFormSchema()
      );
      // }
  };

  validateConfigurationFormSchema = (isAssetNameChanged = false) => {
    const valid = Joi.validate(
          this.state.FormData,
          this.FormSchema,
          {
            abortEarly: false,
          }
        );
    
        const newErrorObject: any = {};
        if (valid.error) {
          valid.error.details.forEach((err) => {
            newErrorObject[err.path.join(".")] = err.message;
          });
        }
        const isDuplicate = this.props.allMaintenanceSchedule.some(
          (x) => x.projectName.toLowerCase() === this.state.FormData.name.toLowerCase()
        );
    
        if (isDuplicate) {
            newErrorObject["name"] = "A schedule with this name already exists. Please choose a unique name";
            this.setState({isDuplicate:true})
        }
        else{
          this.setState({isDuplicate:false})
        }
        if (Object.keys(newErrorObject).length === 0) {
          this.setState({ isFormNotValid: false });
        } else {
          this.setState({ isFormNotValid: true});
        }
        this.setState({ errors: newErrorObject });
        return newErrorObject;
  };



  onFieldChange = (event, inputPosition) => {
    const { FormData } = this.state;
    let value = event.target.value;
    const fieldName = event.target.name;
    if(fieldName === "name" || fieldName === "description"){
      value = value?.toString()?.trimLeft();
    }
    if (fieldName === "frequency") {
      const strippedValue = value.replace(/^0+/, "");
      if (strippedValue === "0" || strippedValue === "") {
        this.setState({ frequenValidation: true, isFormNotValid: true,zeroValidation:true });
      } else {
        value = strippedValue != "" ? strippedValue :value;
        this.setState({ frequenValidation: false, isFormNotValid: false,zeroValidation:false });
      }
    }
    FormData[fieldName] = value;
    this.setState({FormData},()=> {
      this.validationOnClick(inputPosition)
    }); 
  };

  changestartDate = (event, inputPosition) => {
    //debugger

    const { FormData } = this.state;

    let calenderYeare = event.getFullYear().toString().substr(2, 4);
    let calenderDatee =
      event.getDate() > 9 ? event.getDate() : 0 + "" + event.getDate();
    let calenderMonthe =
      event.getMonth() + 1 > 9
        ? event.getMonth() + 1
        : 0 + "" + (event.getMonth() + 1);
    let tempDatee = calenderMonthe + "/" + calenderDatee + "/" + calenderYeare;

    if (inputPosition === 1) {
      FormData['startDate'] = tempDatee;
      if (FormData['endDate'] && moment(FormData['endDate'], "MM/DD/YY").isSameOrBefore(moment(FormData['startDate'], "MM/DD/YY"))) {
          FormData['endDate'] = "";
      }
      this.setState({ calendarOpened: false });
      this.validationOnClick(5);
    } else if (inputPosition === 2) {
      FormData['endDate'] = tempDatee;
      this.setState({ endCalendarOpened: false });
    }


    this.setState({ FormData }, () => {
      // this.resetError();
      //this.validationOnClick(inputPosition);
    });


  }

  changeDuetDate = (event, inputPosition) => {
    //debugger

    const { FormData } = this.state;

    // let calenderYeare = event.getFullYear().toString().substr(2, 4);
    // let calenderDatee =
    //   event.getDate() > 9 ? event.getDate() : 0 + "" + event.getDate();
    // let calenderMonthe =
    //   event.getMonth() + 1 > 9
    //     ? event.getMonth() + 1
    //     : 0 + "" + (event.getMonth() + 1);
    // let tempDatee = calenderMonthe + "/" + calenderDatee + "/" + calenderYeare;

    //FormData['dueDate'] = tempDatee

    this.setState({ FormData, dueDatecalendarOpened: false }, () => {
      this.validationOnClick(inputPosition);
    });


  }

  onFieldChange_1 = (event, inputPosition) => {
    // debugger
    const { FormData } = this.state;
    // let value = event.target.value;
    // const fieldName = event.target.name;

    if (inputPosition === 1) {
      FormData['mainFrequenId'] = event.id;
      if(event.id == 6){
        FormData['frequency'] = '';
        FormData['frequenId'] = 1;
        this.setState({showCustomdropdown : true})} 
      else{
          this.setState({showCustomdropdown : false,zeroValidation:false,frequenValidation: false})}
    } else if (inputPosition === 2) {
      FormData['frequenId'] = event.id;
    }
    // FormData['mainFrequenId'] = event.id;

    // let calenderYeare = event.getFullYear().toString().substr(2, 4);
    // let calenderDatee =
    //   event.getDate() > 9 ? event.getDate() : 0 + "" + event.getDate();
    // let calenderMonthe =
    //   event.getMonth() + 1 > 9
    //     ? event.getMonth() + 1
    //     : 0 + "" + (event.getMonth() + 1);
    // let tempDatee = calenderMonthe + "/" + calenderDatee + "/" + calenderYeare;

    


    this.setState({ FormData,inputPosition }, () => {
      this.resetError();
      //this.validationOnClick(inputPosition);
    });
  };

  // getFieldError = (fieldName: string, fieldPosition: number) => {
  //   const { errors, inputPosition } = this.state;
  //      //debugger;
  //   return (
  //     <>
  //       {/* {Object.keys(errors).length > 0 && fieldPosition <= inputPosition && (
  //         <span className="validation-message">{errors[fieldName]}</span>
  //       )} */}
  //       {Object.keys(errors).length > 0 && fieldPosition <= inputPosition && (
  //         <span className="validation-message validation-error">Please populate all required fields before continuing.</span>
  //       )}
  //     </>
  //   );
  // };

resetError=()=>{
  this.setState({isFormNotValid:false,errors:{}})
}
countUpdate = (state: any,stype:any) => {
  this.setState({tableLocationData:state});
  this.validationOnClick(5)
  // let totalRoom = state.filter(
  //   (x: any) => x.type.toLowerCase() !== "roomtype"
  // );
  //  if(stype!=="notechange"){
  //   this.setState({ isChanges: true,isNew:false });
  //  }
  // this.setState({ isCountLocation: totalRoom.length, tableLocationData: totalRoom });
}
procedureSelection = (item: any, Type: any) => {
        debugger;
        //let tblPDate= _.cloneDeep([...this.state.tableProceuresData]); 
    let astname="";
    if (Type === "add") {
       let data = item;
      let tableProceuresdata= [...this.state.tableProceuresData]; 
      let tableProceuresTempdata: any = [];
      data.forEach(element => {

        if (element.isChecked == "yes") {
          let tempData: any = {};
          let name=element.assetName.split(':')
        if(name.length>0){
          astname=name[1];
        }
          tempData.assetName =  astname;
          tempData.assetTypeId = element.assetTypeId;
          tempData.countTask = element.countTask;
          tempData.hid = element.hid;
          tempData.id = element.id;
          tempData.isChecked = element.isChecked;
          tempData.isGlobal = element.isGlobal;
          tempData.procedureId = element.procedureId;
          tempData.procedureName = element.procedureName;
          tableProceuresTempdata.push(tempData);
        }
      });


      // let tempData: any = {};
      // let element = item;

      //   if (element.isChecked == "yes") {
         
      //     let name=element.assetName.split(':')
      //   if(name.length>0){
      //     astname=name[1];
      //   }
      //     tempData.assetName =  astname;
      //     tempData.assetTypeId = element.assetTypeId;
      //     tempData.countTask = element.countTask;
      //     tempData.hid = element.hid;
      //     tempData.id = element.id;
      //     tempData.isChecked = element.isChecked;
      //     tempData.isGlobal = element.isGlobal;
      //     tempData.procedureId = element.procedureId;
      //     tempData.procedureName = element.procedureName;
      //     //tableProceuresTempdata.push(tempData);
      //   }
      







      // const index = data.findIndex((xvalue) => xvalue.id === item);
     // tblPDate.push(tempData);
      // this.setState({ tableProceuresData: tblPDate, isChanges: true},()=>{
      //   if (this.refAddProcedure.current !== null){
      //     this.refAddProcedure.current.upatedProcedureList(this.state.tableProceuresData);
      //   }
        
      // });
      this.setState({tableProceuresData:[]},()=>{
        this.setState({ tableProceuresData: tableProceuresTempdata, isChanges: true,isNew:false},()=>{
        //      if (this.refAddProcedure.current !== null){
        //   this.refAddProcedure.current.upatedProcedureList(this.state.tableProceuresData);
        // }
        });
      })
      
    }
    if (Type === "remove") {
      debugger;
      // let data = _.cloneDeep([...this.state.tableProceuresData]);
      let data = [...this.state.tableProceuresData];
      const index = data.findIndex((xvalue) => xvalue.procedureId === item);
      if(index!==-1){
      data.splice(index, 1);
      this.setState({ tableProceuresData: data, isChanges: true,isNew:false },()=>{
        // if (this.refAddProcedure.current !== null){
        //   this.refAddProcedure.current.upatedProcedureList(this.state.tableProceuresData);
        // }
        
      });
      }
    }
  }
  // handleProcedureSlideout = (row:any) => {
   
  //   let procedureData:any={};
  //   procedureData.procedureId=row.procedureId;
  //   procedureData.procedureName=row.procedureName;   
  //   let Data:any=[];
    
  //   Data.push(procedureData);

  //   this.setState({ isSlideOut: false,isProcedureRow:Data},()=>{
  //     this.setState({ isProcedureMaintenanceSlideout: true });
  //   });
    
  // }
  selectProcedureList=(procedureList)=>
  {
    this.setState({tableProceuresData:procedureList})
    if (this.refAddProcedure.current !== null){            
      this.refAddProcedure.current.upatedProcedureList(procedureList);
    }
  }
  scrollToDropDown = () => {
    const modalBody = document.querySelector('.modal-body');
    if (modalBody) {
      modalBody.scrollTo({
        top: 460,
        behavior: 'smooth',
      });
    }
  };
  render() {

    const { showAddNewPmProject } = this.props;

    const {
      FormData: {
        name,
        startDate,
        endDate,
        frequency,
        frequenId,
        // location,
        description,
        mainFrequenId
      },
      errors,
      inputPosition,
      freequencyList,
      // mainFrequenId,
      mainFrequencyList,

    } = this.state;
    const columns = [
      {
        dataField: "name",
        text: "Name",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                {row.name}
              </EllipsisWithTooltip>
            </>
          );
        },

      },
      {
        dataField: "assetName",
        text: "Asset",
        headerFormatter: (column) => {
          return (
            <>
              <span>Asset</span>
              <OverlayTrigger 
              overlay={<Tooltip id="asset-info">Procedure applies to assets of a matching type for each location</Tooltip>}
              placement="bottom" 
              delay={{ show: 250, hide: 400 }} 
              >
              <div>
                {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <g clip-path="url(#clip0_361_12954)"><path d="M8.66649 7.33307H7.33315V11.3331H8.66649V7.33307Z" fill="#6A6E73"/><path d="M8.66649 4.66641H7.33315V5.99974H8.66649V4.66641Z" fill="#6A6E73"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.1998 7.9998C15.1998 11.9763 11.9763 15.1998 7.9998 15.1998C4.02335 15.1998 0.799805 11.9763 0.799805 7.9998C0.799805 4.02335 4.02335 0.799805 7.9998 0.799805C11.9763 0.799805 15.1998 4.02335 15.1998 7.9998ZM14.3998 7.9998C14.3998 11.5344 11.5344 14.3998 7.9998 14.3998C4.46518 14.3998 1.5998 11.5344 1.5998 7.9998C1.5998 4.46518 4.46518 1.5998 7.9998 1.5998C11.5344 1.5998 14.3998 4.46518 14.3998 7.9998Z" fill="#6A6E73"/>
                  </g><defs><clipPath id="clip0_361_12954"><rect width="16" height="16" fill="white"/></clipPath></defs>
                  </svg> */}
                {column.assetName}
              </div>
            </OverlayTrigger>
            </>
          )
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            
            row.assetName?.trim().length >= 1 ? 
              <div className={`${(row.assetName?.length >= 1 && row.assetName!==" " ) ? "badge asset-badge" : ""}`}>
                <EllipsisWithTooltip placement="bottom">
                  {row.assetName}
                </EllipsisWithTooltip>
              </div> 
              :
              <></>
          );
        },

      },


      {
        dataField: "",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) => (
          <Dropdown
            // onClick={(e) => {
            //   e.stopPropagation();
            // }}
            className="more-action position-static text-right"
            alignRight
          >
            {/* <Dropdown.Toggle
              className="btn-outline-primary btn btn-primary btn-ghost more"
              id="dropdown-more"
            // disabled={!this.state?.createEditPermission || selectedRows?.length > 0}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
              </svg>
            </Dropdown.Toggle> */}
            {/* <Dropdown.Menu>
              {(Number(row.inUse) !== 1) &&
                <Dropdown.Item
                // onClick={() => this.hanldeDeleteConfirmation(row.id)} 
                >
                  Delete
                </Dropdown.Item>
              }
              <Dropdown.Item
                onClick={() => this.handleProcedureSlideout()}
              >
                Archive
              </Dropdown.Item>
            </Dropdown.Menu> */}
          </Dropdown>
        ),
      },
    ];
    // const tableRowEvents = {
    //   // onClick: (e, row, rowIndex) => {
    //   //   this.handleProcedureSlideout(row)
    //   // },
    // }
    return (
      <>

        <div>
          {/* <ToastContainer containerId={"addDeduction"} autoClose={3000} /> */}

          <Modal
            className="add-room-type-modal add-new-asset add-maintenanace-schedule-modal"
            show={showAddNewPmProject}
            onHide={this.hideNewPmProject}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          // keyboard={this.props?.showDeductionModal}
          >
            <Modal.Header closeButton>
              <Modal.Title>
               New Preventative Maintenance
              </Modal.Title>
            </Modal.Header>
            <Modal.Body >
              <div className="form-section" ref={this.violationRef}>
                <div className="body-section">

                  <Form.Group onBlur={() => this.validationOnClick(1)} className="d-flex">
                    <Col
                      sm={"12"}
                      className={`mb-0 ${errors?.name && inputPosition >= 1
                          ? "validation-error"
                          : ""
                        }`}
                    // onClick={() => this.validationOnClick(1)}
                    >
                      <Form.Label>Name <b>*</b></Form.Label>
                      
                      <Form.Control
                        type="text"
                        className="form-control"
                        // tabIndex={1}
                        maxLength={50}
                        id="name"
                        name="name"
                        autoComplete='off'
                        placeholder="Enter Name"
                        value={name}
                        onChange={(e) => this.onFieldChange(e, 1)}
                        onBlur={() => { this.setState({ FormData: { ...this.state.FormData, name: name.trimRight() } }) }}
                      />                      
                    {errors?.name && inputPosition >= 1 && <div className="error-message">{errors.name}</div>}
                    {/* {this.getFieldError("name", 1)} */}
                    </Col>
                  </Form.Group>
                  <Form.Group  onBlur={() => this.validationOnClick(2)} className="d-flex">
                    <Col
                      sm={"12"}
                      className={`mb-0 ${
                        errors?.description && inputPosition >= 2
                          ? "validation-error"
                          : ""
                      }`}
                      // onClick={() => this.validationOnClick(2)}
                    >
                      <Form.Label>Description <b>*</b></Form.Label>
                      <Form.Control as="textarea"
                      
                        className="form-control"
                        id="description"
                        rows={1}
                        name="description"
                        autoComplete="description"
                        value={description}
                        maxLength={200}
                        placeholder="Describe your PM in a few words"
                        onChange={(e) => this.onFieldChange(e, 2)}
                        onBlur={()=>{this.setState({FormData:{...this.state.FormData,description:description.trimRight()}})}}

                      />
                    {errors?.description && inputPosition >= 2 && <div className="error-message">{errors.description}</div>}
                      {/* {this.getFieldError("description", 5)} */}
                    </Col>
                  </Form.Group>
                    <Form.Group  >

                       <Col
                              sm={"12"}
                              className={`mb-0 col-left ${errors?.frequency && inputPosition >= 3
                                  ? "validation-error1"
                                  : ""
                                }`}
                                >
                      <Form.Label>Frequency <b>*</b></Form.Label>
                      <Form.Group onBlur={() => this.validationOnClick(3)} >
                      <Col
                            sm={"12"}
                            className={`mb-2 ${
                              errors?.mainFrequenId && inputPosition >= 3
                                ? "validation-error"
                                : ""
                            }`}
                            // onClick={() => this.validationOnClick(2)}
                          >
                      <DropDownList
                          // tabIndex={2}
                          placeHolder={"Select Frequency"}
                          id="mainFrequenId"
                          data={this.state.mainFrequencyList}
                          // defaultValue={mainFrequenId}
                          isSearchRequired={true}
                          label={"name"}
                          value={"id"}
                          placeHolderItem={{ id: -1, name: "Select Frequency" }}
                          onDropDownChange={(item) => {
                            if (!item) {
                              return;
                            }
                            this.onFieldChange_1(
                              item, 1
                            );
                          }}
                          selectedItem={
                            this.state.mainFrequencyList.find(
                              (r: any) => r.id === mainFrequenId
                            ) || { id: -1, name: "Select Frequency" }
                          }
                        />
                        {errors?.mainFrequenId && inputPosition >= 3 && <div className="error-message">{errors.mainFrequenId}</div>}
                        </Col>
                        </Form.Group>
                        {this.state.showCustomdropdown && (
                        <div className="d-flex input-row">
                        
                          {this.state.frequenValidation}
                          <Form.Group
                           onBlur={() => this.validationOnClick(4)}
                             style={{ width: "25%" }} className="mb-0">
                            <Col
                              sm={"12"}
                              className={`mb-0 col-left d-flex align-items-baseline ${errors?.frequency && inputPosition >= 4 || this.state.frequenValidation ? "validation-error" : ""}`}
                            // onClick={() => this.validationOnClick(1)}
                            >
                                <span className="mr-2">Every</span>
                                <Form.Control
                                  type="text"
                                  inputMode="numeric"
                                  className="form-control mb-3"
                                  pattern="[0-9]*"
                                  maxLength={3}
                                  // tabIndex={1}
                                  // min={1}
                                  id="txtassetName"
                                  name="frequency"
                                  autoComplete="frequency"
                                  value={frequency}
                                  onKeyDown={Utils.AllowOnlyPositiveNumnberInputWithoutDot}
                                  onChange={(e) => this.onFieldChange(e, 3)}
                                  onBlur={() => { this.setState({ FormData: { ...this.state.FormData, frequency: frequency.trimRight() } }) }}
                                /> 
                                
                              {/* {this.state.priorityList.length > 0 &&   */}

                              {/* <DropDownList
                                placeHolder={"Select Frequency"}
                                data={this.state.freequencyList}
                                defaultValue={"Select Frequency"}
                                isSearchRequired={false}
                                label={"name"}
                                value={"id"}
                                placeHolderItem={{ id: -1, name: "Select Frequency" }}  
                              /> */}

                            </Col>
                          </Form.Group>
                          
                         {/* {this.getFieldError("frequency", 1)} */}
                          <Form.Group
                            // onBlur={() => this.validationOnClick(4)}
                             style={{ width: "30%" }}>
                            <Col
                              sm={"12"}
                              className={`mb-0 col-right`}
                            //   onBlur={() => this.validationOnClick(2)}
                            >
                              {/* <Form.Label>Asset Type</Form.Label> */}

                              {this.state.freequencyList.length > 0 && <DropDownList
                                // tabIndex={2}
                                placeHolder={"Select Frequency"}
                                data={this.state.freequencyList}
                                defaultValue={frequenId}
                                isSearchRequired={true}
                                label={"name"}
                                value={"id"}
                                placeHolderItem={{ id: -1, name: "Select Frequency" }}
                                onDropDownChange={(item) => {
                                  if (!item) {
                                    return;
                                  }
                                  this.onFieldChange_1(
                                    item, 2
                                  );
                                }}
                                selectedItem={[
                                  ...[{ id: -1, name: "Select Frequency" }],
                                  ...freequencyList,
                                ].find((r: any) => r?.id === frequenId)}
                              />}

                              {/* {this.getFieldError("assetType", 2)} */}
                            </Col>
                          </Form.Group>

                        </div>
                       )}
                       {errors?.frequency && this.state.showCustomdropdown && inputPosition >= 4 && <div className=" pt-0 error-message">{errors.frequency}</div>}
                       {this.state.zeroValidation && !errors?.frequency && <div className=" pt-0 error-message">Please enter a value greater than 0</div>}
                      </Col>
                    </Form.Group>
                    <Form.Group onBlur={() => this.validationOnClick(5)}>

                      <Col className={`pl-0  ${errors?.startDate && inputPosition >= 5
                          ? "validation-error"
                          : ""
                        }`}
                        sm={"12"}>
                        <Form.Label>Start Date <b>*</b></Form.Label>
                       
                        <div className="calender-picker input-form-calender">
                          <Form.Control placeholder="Select Start Date"
                            autoComplete='off'
                            type="text" id="openingDate" name='startDate'
                            value={startDate}
                            // ref={this.openingDateRef}
                            onClick={() => this.openCalendar(1)}
                          />
                          <div className="icon" onClick={() => this.openCalendar(1)}>
                            <span className="calender-icon">
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z"></path>
                                <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z"></path>
                              </svg>
                            </span>
                          </div>
                          {this.state.calendarOpened
                            ?
                            <OutsideClickHandler
                              onOutsideClick={this.calenderHide}
                            >
                              <div className="calender startDate">
                                <Calendar
                                  calendarType={"US"}
                                  onChange={(e) => this.changestartDate(e, 1)}
                                  value={
                                    this.state.FormData.startDate
                                    ? moment(this.state.FormData.startDate)?.format(
                                        "MM/DD/YY"
                                      ) === "Invalid date"
                                      ? ""
                                      : new Date(this.state.FormData.startDate)
                                    : ""
                                  } 
                                  minDate={this.state.currentDate}
                                />
                              </div>
                            </OutsideClickHandler>
                            : null}
                        </div>
                        {errors?.startDate && inputPosition >= 5 && <div className="error-message">{errors.startDate}</div>}

                        {/* {this.getFieldError("startDate", 1)} */}
                        {/* {errors.openingDate.length > 0 &&
                                    <span className='error'>{errors.openingDate}</span>
                                } */}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      // onBlur={() => this.validationOnClick(3)}
                      >

                      <Col className={`pl-0`}
                        sm={"12"}>
                        <Form.Label>End Date </Form.Label>
                       
                        <div className="calender-picker input-form-calender">
                          <Form.Control placeholder="Select End Date"
                            autoComplete='off'
                            type="text" id="openingDate" name='endDate'
                            value={endDate}
                            // ref={this.openingDateRef}
                            onClick={() => this.openCalendar(2)}
                          />
                          <div className="icon">
                            {this.state.FormData.endDate &&
                          <svg  onClick={() => this.closeCalendar(1)} xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                            <path d="M1 1L9 9M1 9L9 1" stroke="#84888C" stroke-width="2"/>
                          </svg>
                          }
                          <span className="calender-icon ml-2">
                              <svg onClick={() => this.openCalendar(2)} 
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z"></path>
                                <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z"></path>
                              </svg>
                            </span>
                          </div>
                          {this.state.endCalendarOpened
                            ?
                            <OutsideClickHandler
                              onOutsideClick={this.calenderHide}
                            >
                              <div className="calender startDate">
                                <Calendar
                                  calendarType={"US"}
                                  onChange={(e) => this.changestartDate(e, 2)}
                                  value={
                                    this.state.FormData.endDate
                                    ? moment(this.state.FormData.endDate)?.format(
                                        "MM/DD/YY"
                                      ) === "Invalid date"
                                      ? ""
                                      : new Date(this.state.FormData.endDate)
                                    : ""
                                  } 
                                  minDate={this.state.FormData.startDate ? moment(this.state.FormData.startDate).add(1, 'days').toDate() : ""}
                                />
                              </div>
                            </OutsideClickHandler>
                            : null}
                        </div>
                      </Col>
                    </Form.Group>
                    <div id="maintenance-slideout" ><div className="body-sec">
                    <div className="select-users">
                    <Form.Group >
                    <Form.Label>Locations <b>*</b></Form.Label>
                      <MaintenanceLocationSlideOut
                        // ref={this.refMaintenanceLocationSlideOut}
                        // conflictCheck="Actual"
                        parentState={this.state}
                        countUpdate={this.countUpdate}
                        scrollToDropDown={this.scrollToDropDown}
                        // disabled={!createEditPermission}
                        //discardChanges={}
                      // procedureSelection={this.procedureSelection}
                      // multiSelectErrorValidation={this.multiSelectErrorValidation}
                      />
                    </Form.Group>
                    <Form.Group className="mb-0">
                    <Form.Label>Procedures </Form.Label>
                    <div className="maintenance-procedure-tbl">
                        <div className="block-bar"></div>
  
                        <BootstrapTable
                          //id={"procuers"}
                          // {...props.baseProps}
                          keyField="ID"
                          data={this.state.tableProceuresData}
                          columns={columns}
                          // rowEvents={tableRowEvents}
                        // hover
  
                        // selectRow={selectRow}
  
                        />
  
                      </div>
                      <AddProcedure
                        ref={this.refAddProcedure}
                        conflictCheck="Actual"
                        // parentState={_.cloneDeep(this.state)}
                        parentState={this.state}
                        selectProcedureList={this.selectProcedureList}
                        assetTypes={this.props.assetTypes}
                        // procedureSelection={this.procedureSelection}
                        // disabled={!createEditPermission}
                      // multiSelectErrorValidation={this.multiSelectErrorValidation}
                      />
                    </Form.Group>
                  </div></div></div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                  // tabIndex={9}
                  className="btn-ghost"
                  onClick={this.hideNewPmProject}
                >
                  Cancel
                </Button>
              <Button
                disabled={!this.isFormCompletelyValid()}
                className="btn btn-primary"

                onClick={this.onSaveMaintenance}
              >
                Save
              </Button>
            </Modal.Footer>
          </Modal>
        </div>



      </>
    );
  }

}